// eslint-disable-next-line
export interface Notification<T = any> {
  userNotificationId: number
  type: NotificationType
  payload: T
  status: boolean
  creationDate: string
}

export interface GroupInvitePayload {
  token: string,
  group: {
    groupId: number
    name: string
  },
  user: {
    id: string
    userName: string
  }
}

export enum NotificationType {
  GroupInvite = "GROUP_PENDING"
}
